<div class="spinner-container" [class]="sizeClass()">
      @if (variant() === 'dots') {
        <div class="dots-spinner">
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
        </div>
      } @else if (variant() === 'pulse') {
        <div class="pulse-spinner">
          <div class="pulse-ring"></div>
          <div class="pulse-ring"></div>
          <div class="pulse-ring"></div>
        </div>
      } @else {
        <svg
          class="circular-spinner"
          [class.text-primary]="color() === 'primary'"
          [class.text-white]="color() === 'white'"
          [class.text-current]="color() === 'current'"
          viewBox="0 0 24 24"
          fill="none">
          <circle
            class="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            stroke-width="4">
          </circle>
          <path
            class="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
          </path>
        </svg>
      }
    </div>
